import React, { useState, useEffect } from 'react';
import { useTheme, IconButton, TablePagination, Stack, Tooltip, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { CancelToken } from 'apisauce';
import * as moment from 'moment';
import { Box } from '@mui/system';

import TablePaginationActions from '../../../components/TablePaginationActions';
import PageHeader from '../../../components/PageHeader';
import appapi from '../../../api/apiClient';
import Datatable from '../../../components/DataTable';
import Layout from '../../../components/Layout';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { checkPermission } from '../../../redux/features/authSlice';

const module = [
  {
    id: 1,
    name: 'Authentication',
    value: 'Authentication'
  },
  {
    id: 2,
    name: 'Company Management',
    value: 'Company'
  },
  {
    id: 3,
    name: 'Trader Management',
    value: 'Trader'
  },
  {
    id: 4,
    name: 'Verifier Management',
    value: 'Verifier'
  },
];

const moduleToNewName = {
  "authentication" : "Authentication",
  "company": "Company Management",
  "trader": "Trader Management",
  "verifier": "Verifier Management",
}

export default function ActivityLogMain() {
  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
    },
    {
      id: 1,
      header: 'User Name',
      accessor: 'userName',
      width: '15%',
      search: false,
    },
    {
      id: 2,
      header: 'Module',
      accessor: 'referenceName',
      width: '15%',
      capitalize: true,
      filter: {
        search: false,
        filterType: 'checkbox',
        typeFilter: true,
        filterList:
          module?.map((item) => {
            return {
              label: item?.name,
              id: item?.id,
            };
          }) || [],
      },
    },
    {
      id: 3,
      header: 'Action',
      accessor: 'log',
      width: '50%',
      capitalize: true,
    },
    {
      id: 4,
      header: 'Date & Time',
      accessor: 'createdOn',
      width: '15%',
    },
  ];

  const theme = useTheme();
  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    field: '_id',
    sortOrder: 'desc',
    moduleFilter: null
  });
  let source = CancelToken.source();
  const [isLoading, setIsLoading] = useState(true);
  const [activityList, setActivityList] = useState([]);
  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  /**
   * retrieving user From Redux Store
   */
  // const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const permission = useSelector((state) => checkPermission(state, 'Vehicle Details'));
  /**
   *
   *
   *
   * @function handleChangePage
   * @function handleChangeRowsPerPage
   * handle Pagination
   */
  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, filter: search }));
  };

  const handleGetActivity = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/common/auditLog`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        status: payload.status,
        field: payload.field,
        sortOrder: payload.sortOrder,
        moduleFilter: payload.moduleFilter
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          item.referenceName = moduleToNewName[item?.referenceName.toLowerCase()] || item?.referenceName; 
          item.createdOn = moment(item.createdOn).format('DD-MMM-YYYY | hh:mm A')
          return item;
          
        });
        setActivityList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setActivityList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0,  paginationPage: 0,  }));
        setIsLoading(false);
      }
    } else {
      setActivityList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0,  paginationPage: 1}));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetActivity();
    return () => {
      if(source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.moduleFilter, payload.field, payload.sortOrder]);

  return (
    <Layout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems={'inherit'}
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <Stack className="w-[100%]">
          <PageHeader
            headerTittle={`ACTIVITY LOG`}
            handleOnSearchEmit={(search) => {
              handleSearchEmit(search);
            }}
            placeholder={'User name, Action'}
            userPermission={''}
          />
        </Stack>
        <Stack>
          <TablePagination
            rowsPerPageOptions={[]}
            count={payload.totalLength ? payload.totalLength : 0}
            rowsPerPage={payload.limit ? payload.limit : 10}
            page={payload.paginationPage ? payload.paginationPage : 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Stack>
      </Stack>
      <Box sx={{ width: '100%' }}>
        <Datatable
          data={activityList || []}
          columns={customerManagementColumn}
          isLoading={isLoading}
          onChangeFilter={(filterValues) => {
            const columnUpdate = customerManagementColumn;
            columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
            setCustomerManagementColumn(columnUpdate);
              setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, moduleFilter: filterValues.filter.selectValue ? module.filter((res) => filterValues.filter.selectValue.includes(res.id)).map((res) => res.value): null }));
          }}
          onChangeSort={(sortValues) => {
            const columnUpdate = [...customerManagementColumn];
            columnUpdate[sortValues?.id].sortOrder = sortValues.order;
            columnUpdate[sortValues?.id].sortActive = sortValues.sortActive;
            setCustomerManagementColumn([...columnUpdate]);
            setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.accessor, sortOrder: sortValues.order }));
          }}
        />
      </Box>
    </Layout>
  );
}
